/**
 * blog-sds.js
 * Elite Ti — Blog page JS
 * Handles: category filter, GSAP card entrance, stacked scroll cards,
 * reading progress bar, ToC heading tracker, FAQ accordions
 */
(function () {
  'use strict';

  /* ── Global reading progress & TOC scroll listener (prevents duplicate customizer bindings) ── */
  if (!window.blogSdsProgressBound) {
    var globalUpdateScrolls = function(event) {
      // 1. Progress Bar Update
      var page = document.querySelector('.blog-article-sds-page');
      if (!page) return;

      var container = page.querySelector('.blog-article-content');
      if (!container) return;

      var pct = 0;
      var windowScroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      var containerRect = container.getBoundingClientRect();
      var containerTop = containerRect.top + windowScroll;
      var containerHeight = containerRect.height;
      
      var startY = containerTop - window.innerHeight * 0.1;
      var endY = containerTop + containerHeight - window.innerHeight * 0.9;
      
      var totalScroll = endY - startY;
      var currentScroll = windowScroll - startY;
      
      if (totalScroll > 0) {
        pct = Math.min(100, Math.max(0, (currentScroll / totalScroll) * 100));
      } else {
        pct = 100;
      }
      
      // Update global CSS custom property
      document.documentElement.style.setProperty('--progress', pct + '%');
      page.style.setProperty('--progress', pct + '%');

      var fills = document.querySelectorAll('.blog-article-progress-bar__fill, .blog-sidebar-progress-bar-fill');
      fills.forEach(function (fill) {
        fill.style.width = pct + '%';
        fill.style.setProperty('width', pct + '%', 'important');
        fill.style.setProperty('--progress', pct + '%');
      });

      var pctEls = document.querySelectorAll('.blog-sidebar-progress-pct');
      pctEls.forEach(function (pctEl) {
        pctEl.textContent = Math.round(pct) + '%';
      });



      // 2. Table of Contents (TOC) Active Indicator Update
      var currentTocItems = page.querySelectorAll('.blog-sidebar-toc-item');
      var currentHeadings = page.querySelectorAll('.blog-stacked-card__heading[id]');
      if (currentTocItems.length && currentHeadings.length) {
        var activeIdx = 0;
        var STICKY_TOP = 100;
        var STACK_OFFSET = 32;

        currentHeadings.forEach(function (h, i) {
          var card = h.closest('.blog-stacked-card');
          if (card) {
            var rect = card.getBoundingClientRect();
            var triggerY = STICKY_TOP + (i * STACK_OFFSET) + 15;
            if (rect.top <= triggerY) {
              activeIdx = i;
            }
          }
        });

        // Trigger last heading active when scrolled near bottom of the page
        var windowHeight = window.innerHeight;
        var documentHeight = document.documentElement.scrollHeight;
        var windowScroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
        if (windowScroll + windowHeight >= documentHeight - 60) {
          activeIdx = currentHeadings.length - 1;
        }

        currentTocItems.forEach(function (item, i) {
          item.classList.remove('active', 'past');
          var indicator = item.querySelector('.blog-sidebar-toc-indicator');
          var check = item.querySelector('.blog-sidebar-toc-check');

          if (i < activeIdx) {
            item.classList.add('past');
            if (indicator) indicator.style.display = 'none';
            if (check) check.style.display = 'block';
          } else if (i === activeIdx) {
            item.classList.add('active');
            if (indicator) indicator.style.display = 'block';
            if (check) check.style.display = 'none';
          } else {
            if (indicator) indicator.style.display = 'block';
            if (check) check.style.display = 'none';
          }
        });
      }
    };

    // Use event capturing (capture: true) to intercept scroll events from any sub-containers that don't bubble
    window.addEventListener('scroll', globalUpdateScrolls, { passive: true, capture: true });
    document.addEventListener('scroll', globalUpdateScrolls, { passive: true, capture: true });

    window.blogSdsProgressBound = true;
    window.blogSdsUpdateProgress = globalUpdateScrolls;
  }

  /* ── Category accent colours (match local preview exactly) ── */
  var CAT_COLORS = {
    'MOTORSPORTS': '#c0f20c',
    'TECH GUIDES': '#00f0ff',
    'DESIGN STUDIES': '#ff6b35'
  };

  var DEFAULT_ACCENT = '#c0f20c';

  function accentFor(category) {
    return CAT_COLORS[category] || DEFAULT_ACCENT;
  }

  /* ══════════════════════════════════════════════════════════
     LIST PAGE — blog-list-sds
     ══════════════════════════════════════════════════════════ */
  /* ── Category filter ── */
  function initBlogList(container) {
    var wrapper = container.querySelector('blog-list-sds');
    if (!wrapper && container.tagName === 'BLOG-LIST-SDS') {
      wrapper = container;
    }
    if (!wrapper) return;

    var filterBtns = wrapper.querySelectorAll('.blog-sds-filter-btn');
    var cards = wrapper.querySelectorAll('.blog-sds-card, .blog-sds-featured');

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.dataset.category;
        filterBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        var allCards = wrapper.querySelectorAll('[data-category]');
        var allFeatured = wrapper.querySelectorAll('.blog-sds-featured');

        allCards.forEach(function (el) {
          var elCat = el.dataset.category;
          var show = cat === 'ALL' || elCat === cat;
          el.style.display = show ? '' : 'none';
        });

        allFeatured.forEach(function (el) {
          el.style.display = (cat !== 'ALL') ? 'none' : '';
        });

        triggerEntrance(wrapper);
      });
    });

    triggerEntrance(wrapper);
  }

  function triggerEntrance(wrapper) {
    var items = wrapper.querySelectorAll('.blog-sds-card, .blog-sds-featured');
    items.forEach(function (el, i) {
      el.classList.remove('is-visible');
      el.style.transitionDelay = (i * 0.08) + 's';
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        items.forEach(function (el) {
          el.classList.add('is-visible');
        });
      });
    });
  }

  /* ══════════════════════════════════════════════════════════
     ARTICLE PAGE — blog-article-sds
     ══════════════════════════════════════════════════════════ */
  function initBlogArticle(page) {
    var STICKY_TOP = 80;
    var STACK_OFFSET = 32;

    // Temporary Visual Debug Console
    var debugLog = function(msg) {
      console.log('[blog-sds]', msg);
    };

    window.addEventListener('error', function(e) {
      debugLog('ERROR: ' + e.message);
    });

    // 0. Auto-parse FAQs from plain text tags inside stacked cards
    var parseArticleFAQs = function() {
      var cards = page.querySelectorAll('.blog-stacked-card');
      cards.forEach(function (card) {
        var heading = card.querySelector('h2');
        if (!heading || !heading.textContent.toUpperCase().includes('FAQ')) return;

        var contentArea = card.querySelector('.rte');
        if (!contentArea) return;

        // Skip if already parsed
        if (contentArea.querySelector('.blog-article-faqs-container')) return;

        // Group headers and paragraphs
        var children = Array.prototype.slice.call(contentArea.children);
        var faqGroups = [];
        var currentGroup = null;

        children.forEach(function (child) {
          var isHeader = ['H3', 'H4', 'H5', 'H6', 'STRONG', 'B'].indexOf(child.tagName) > -1;
          if (child.tagName === 'P' && child.children.length === 1 && ['STRONG', 'B'].indexOf(child.children[0].tagName) > -1) {
            isHeader = true;
            child = child.children[0];
          }

          if (isHeader) {
            if (currentGroup) {
              faqGroups.push(currentGroup);
            }
            currentGroup = {
              question: child.textContent.trim(),
              answerNodes: [],
              originalNodes: [child]
            };
          } else if (currentGroup) {
            currentGroup.answerNodes.push(child.cloneNode(true));
            currentGroup.originalNodes.push(child);
          }
        });

        if (currentGroup) {
          faqGroups.push(currentGroup);
        }

        if (faqGroups.length === 0) return;

        // Clear original nodes
        faqGroups.forEach(function (group) {
          group.originalNodes.forEach(function (node) {
            if (node.parentNode) {
              node.parentNode.removeChild(node);
            }
          });
        });

        // Build the accordion details elements
        var faqContainer = document.createElement('div');
        faqContainer.className = 'blog-article-faqs-container';
        faqContainer.style.marginTop = '24px';

        faqGroups.forEach(function (group, index) {
          var numStr = 'Q' + (index + 1 < 10 ? '0' + (index + 1) : (index + 1));
          
          var details = document.createElement('details');
          details.className = 'blog-article-faq-item';
          
          var summary = document.createElement('summary');
          summary.className = 'blog-article-faq-trigger';
          
          summary.innerHTML = `
            <div class="blog-article-faq-trigger__left">
              <span class="blog-article-faq-trigger__num">${numStr}</span>
              <span class="blog-article-faq-trigger__q">${group.question}</span>
            </div>
            <svg class="blog-article-faq-trigger__chevron" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
            </svg>
          `;

          var answerWrap = document.createElement('div');
          answerWrap.className = 'blog-article-faq-answer';
          
          var answerInner = document.createElement('div');
          answerInner.className = 'blog-article-faq-answer__inner';
          
          group.answerNodes.forEach(function (node) {
            answerInner.appendChild(node);
          });

          answerWrap.appendChild(answerInner);
          details.appendChild(summary);
          details.appendChild(answerWrap);
          faqContainer.appendChild(details);
        });

        contentArea.appendChild(faqContainer);
      });
    };

    // Run dynamic parsing first
    parseArticleFAQs();

    // 1. Stacked scroll cards logic
    var runStackedCards = function() {
      var cards = page.querySelectorAll('.blog-stacked-card');
      if (!cards.length) return;



      debugLog('--- Card Stack Debug ---');
      var stackRegardless = page.getAttribute('data-stack-regardless') === 'true';
      debugLog('stackRegardless: ' + stackRegardless);
      debugLog('window.innerHeight: ' + window.innerHeight);

      // Disable stacking on mobile (screen width < 768px)
      if (window.innerWidth < 768) {
        debugLog('MOBILE SCREEN DETECTED - STACKING DISABLED');
        cards.forEach(function (card) {
          card.classList.remove('is-sticky');
          card.style.top = '';
          card.style.zIndex = '';
        });
        return;
      }

      cards.forEach(function (card, i) {
        card.classList.remove('is-sticky');
        card.style.top = '';
        card.style.zIndex = i + 1;

        var cardHeight = card.offsetHeight;
        var availableHeight = window.innerHeight - STICKY_TOP - (i * STACK_OFFSET);

        var shouldStick = i < cards.length - 1;
        if (!stackRegardless) {
          shouldStick = shouldStick && (cardHeight < availableHeight);
        }

        debugLog('Card ' + (i+1) + ': height=' + cardHeight + ', avail=' + availableHeight + ', sticky=' + shouldStick);

        if (shouldStick) {
          card.classList.add('is-sticky');
          card.style.top = (STICKY_TOP + i * STACK_OFFSET) + 'px';
        }
      });
    };

    runStackedCards();

    // Dynamic class toggling to add '.is-covered' when a card is scrolled past/covered by the next card
    var updateStickyState = function() {
      var cards = page.querySelectorAll('.blog-stacked-card');
      if (!cards.length) return;

      cards.forEach(function (card, i) {
        if (i === cards.length - 1) return; // Last card is never covered by a next card

        var nextCard = cards[i + 1];
        if (!nextCard) return;

        var nextRect = nextCard.getBoundingClientRect();
        var currentStickyY = STICKY_TOP + i * STACK_OFFSET;

        // If the next card has scrolled up to or past the current card's header tab bottom limit
        if (nextRect.top <= currentStickyY + STACK_OFFSET + 10) {
          card.classList.add('is-covered');
        } else {
          card.classList.remove('is-covered');
        }
      });
    };

    var handleResize = function() {
      runStackedCards();
      updateStickyState();
    };

    var handleScroll = function() {
      updateStickyState();
    };

    var handleLoad = function() {
      runStackedCards();
      updateStickyState();
    };

    // Clean up previous event listeners if they exist to prevent duplicates in the Shopify Editor
    if (window.blogSdsResizeHandler) {
      window.removeEventListener('resize', window.blogSdsResizeHandler);
    }
    if (window.blogSdsScrollHandler) {
      window.removeEventListener('scroll', window.blogSdsScrollHandler);
    }
    if (window.blogSdsLoadHandler) {
      window.removeEventListener('load', window.blogSdsLoadHandler);
    }

    // Save references to the current handlers
    window.blogSdsResizeHandler = handleResize;
    window.blogSdsScrollHandler = handleScroll;
    window.blogSdsLoadHandler = handleLoad;

    window.addEventListener('resize', window.blogSdsResizeHandler);
    window.addEventListener('scroll', window.blogSdsScrollHandler);
    window.addEventListener('load', window.blogSdsLoadHandler);
    updateStickyState();

    // Observe the main content container instead of individual cards to prevent loop limits
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function() {
        runStackedCards();
        updateStickyState();
      });
      var container = page.querySelector('.blog-article-content');
      if (container) {
        ro.observe(container);
      }
    }

    // 2. Reading progress bar logic
    if (window.blogSdsUpdateProgress) {
      window.blogSdsUpdateProgress();
      window.addEventListener('load', window.blogSdsUpdateProgress);
      setTimeout(window.blogSdsUpdateProgress, 600);
    }

    // 3. Table of Contents / Active heading tracker logic
    var tocItems = page.querySelectorAll('.blog-sidebar-toc-item');
    var headings = page.querySelectorAll('.blog-stacked-card__heading[id]');

    if (tocItems.length && headings.length) {
      if (window.blogSdsUpdateProgress) {
        window.blogSdsUpdateProgress();
      }

      // Smooth scroll on ToC click
      tocItems.forEach(function (item) {
        item.addEventListener('click', function (e) {
          e.preventDefault();
          var target = item.getAttribute('href');
          if (target) {
            var el = page.querySelector(target);
            if (el) {
              var card = el.closest('.blog-stacked-card');
              if (card) {
                var container = page.querySelector('.blog-article-content');
                var containerTop = container ? (container.getBoundingClientRect().top + window.scrollY) : 0;
                var absoluteTop = containerTop + card.offsetTop - 85;
                window.scrollTo({ top: absoluteTop, behavior: 'smooth' });
              } else {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }
          }
        });
      });
    }

    // 4. FAQ accordions inside articles (supports both generic elements and DETAILS/SUMMARY elements)
    var faqItems = page.querySelectorAll('.blog-article-faq-item');
    faqItems.forEach(function (item) {
      var trigger = item.querySelector('.blog-article-faq-trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        if (item.tagName === 'DETAILS') {
          e.preventDefault(); // Control state toggles manually to close siblings
        }

        var isOpen = item.classList.contains('open') || item.hasAttribute('open');

        // Close all other accordions (handles both class and details attribute)
        faqItems.forEach(function (i) {
          i.classList.remove('open');
          if (i.tagName === 'DETAILS') {
            i.removeAttribute('open');
          }
        });

        // Toggle clicked element
        if (!isOpen) {
          item.classList.add('open');
          if (item.tagName === 'DETAILS') {
            item.setAttribute('open', '');
          }
        }
      });
    });
  }

  /* ══════════════════════════════════════════════════════════
     INIT
     ══════════════════════════════════════════════════════════ */
  function init(event) {
    var container = event && event.target ? event.target : document;

    var blogList = container.querySelector('blog-list-sds');
    if (!blogList && container.tagName === 'BLOG-LIST-SDS') {
      blogList = container;
    }
    if (blogList) {
      initBlogList(blogList);
    }

    var blogArticle = container.querySelector('.blog-article-sds-page');
    if (!blogArticle && container.classList && container.classList.contains('blog-article-sds-page')) {
      blogArticle = container;
    }
    if (blogArticle) {
      initBlogArticle(blogArticle);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  // Expose accent helper for Liquid inline usage
  window.blogSdsAccent = accentFor;
})();
